import { skipToken, useQuery } from '@tanstack/react-query';
import { getV1CompaniesCompanyIdAddOnsId } from '@treadinc/horizon-api-spec';
import { t } from 'i18next';

import { AddOn } from '~hooks/useAddOns/models';
import reportRequestError from '~services/reportRequestError';

export default function useAddOnQuery(companyId: string, addOnId: string | null) {
  const { data } = useQuery({
    queryKey: ['addOn', companyId, addOnId],
    queryFn: addOnId
      ? async ({ signal }) => {
          try {
            const response = await getV1CompaniesCompanyIdAddOnsId({
              path: { 'company-id': companyId, id: addOnId },
              signal,
            });

            return AddOn.parse(response.data.data);
          } catch (error) {
            reportRequestError(error, t('error_messages.add_ons.failed_to_fetch'));
            throw error;
          }
        }
      : skipToken,
    retry: false,
  });

  return { addOn: data ?? null };
}
